module.exports = __webpack_public_path__ + "img/cashback.8356229e.png";